import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetInventories } from "../../Store/Thunk";
import InventoryListRow from "./InventoryListRow";
import LeanModal from "./Modal/LeanModal";
import ScrollableCard from "../../../../../SharedComponents/ScrollableCard";

export default function InventoryList({ isArchiveActive }) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(GetInventories());
  }, []);

  const inventories = useSelector((state) => state.inventory.inventories);

  return (
    <>
      <LeanModal />
      <ScrollableCard>
        {inventories?.map(
          (inv, i) => inv.isArchive === isArchiveActive && <InventoryListRow inventory={inv} key={i} />
        )}
      </ScrollableCard>
    </>
  );
}
